import { 
  Button,
  Flex,
  Image, 
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text, 
} from '@chakra-ui/react';

// Assets
import overduePaymentPopup from 'assets/img/overdue-payment-popup.png';

// Components
import { ErrorIcon } from 'components/Icons/Icons';

const OverduePaymentModal = ({ onOpen, isOpen, onClose, handle, isUpdatePaymentBtnLoading}) => {
    return (
    	<> 
        <Modal isOpen={isOpen} onClose={onClose}>
			<ModalOverlay />
			<ModalContent className="modal__simple" 
			    maxW={{ sm: '620px' }} 
			    padding="0px !important"
			    style={{ border:'1px solid #2ABDFD', overflow: 'hidden' }}>
				<ModalCloseButton style={{zIndex: '9'}} />
				<Box h="265px" overflow="hidden">
					<Image
						src={overduePaymentPopup}
						h="100%"
						w="100%"
						objectFit="cover"
    					objectPosition="center"
						maxW="100%"
						transform="scale(1.04)"
					 	/>
				</Box>

				<Box p="24px" textAlign="center">
					<Flex gap="10px" alignItems="center" justifyContent="center">
                       	<ErrorIcon fontSize="24px" />
                        <Text variant="title-lg" fontSize="32px" fontStyle="italic" fontWeight="700">Payment Failed</Text>
                    </Flex>

					<Text textAlign="center" mt="16px" fontStyle="italic" p={{base: '0', md: '0 70px'}}>
					  You have an overdue payment for your LMCT+ subscription. Some benefits are temporarily unavailable.
					</Text>

					<Button 
						isLoading={isUpdatePaymentBtnLoading} 
						mt="40px" 
						variant="button-md" 
						onClick={handle}>Update Payment</Button>
				</Box>
			</ModalContent>
        </Modal> 
        </>
    );
};

export default OverduePaymentModal;